// ===========================================================================
// Charge Capture (Módulo N) — Constantes del módulo.
//
// Catálogos alineados al ciclo de vida del charge (doc §4.1) y al detector
// de missing charges (§3.3). Los `tone` mapean a la paleta semántica del
// Clinical Design System (ok/warn/crit/info/muted).
// ===========================================================================

export const CHARGE_CAPTURE_BASE_PATH = "/charge-capture";

// Estados del charge a lo largo del ciclo de vida (doc §4.1).
export const CHARGE_STATUS = {
  DRAFT:       { key: "DRAFT",       label: "Draft",          tone: "muted" },
  RECOMMENDED: { key: "RECOMMENDED", label: "AI Recommended", tone: "info" },
  IN_REVIEW:   { key: "IN_REVIEW",   label: "In Review",      tone: "warn" },
  APPROVED:    { key: "APPROVED",    label: "Approved",       tone: "ok" },
  SYNCED_AMD:  { key: "SYNCED_AMD",  label: "Synced (AMD)",   tone: "ok" },
  BILLED:      { key: "BILLED",      label: "Billed",         tone: "ok" },
  PAID:        { key: "PAID",        label: "Paid",           tone: "ok" },
  DENIED:      { key: "DENIED",      label: "Denied",         tone: "crit" },
  REJECTED:    { key: "REJECTED",    label: "Rejected",       tone: "crit" },
};

// Severidad de missing charges por horas transcurridas — claves y rangos del
// backend real (GET /api/charge-capture/missing → items[].severity).
export const MISSING_SEVERITY = {
  NORMAL:   { key: "NORMAL",   label: "Normal (≤24h)",    tone: "muted" },
  WARNING:  { key: "WARNING",  label: "Warning (24–48h)", tone: "info" },
  HIGH:     { key: "HIGH",     label: "High (48–72h)",    tone: "warn" },
  CRITICAL: { key: "CRITICAL", label: "Critical (>72h)",  tone: "crit" },
};

/** Resuelve la severidad del backend ("Critical") al catálogo local. */
export const resolveMissingSeverity = (severity) =>
  MISSING_SEVERITY[String(severity || "").toUpperCase()] || MISSING_SEVERITY.NORMAL;

// Confianza del recommendation engine (doc §3.1).
export const CONFIDENCE = {
  HIGH:   { key: "HIGH",   label: "High",   tone: "ok" },
  MEDIUM: { key: "MEDIUM", label: "Medium", tone: "warn" },
  LOW:    { key: "LOW",    label: "Low",    tone: "muted" },
};

// Resultado de cada validación (doc §3.2).
export const VALIDATION_RESULT = {
  PASS:    { key: "PASS",    label: "Pass",    tone: "ok" },
  WARNING: { key: "WARNING", label: "Warning", tone: "warn" },
  FAIL:    { key: "FAIL",    label: "Fail",    tone: "crit" },
};

// Tabs principales del módulo.
export const CHARGE_CAPTURE_TABS = {
  QUEUE:   "queue",
  MISSING: "missing",
  METRICS: "metrics",
};
